export default [
  {
    title: 'Startseite',
    route: 'TA-Home',
    icon: 'AirplayIcon',
    resource: 'TAR0',
    action: 'read',
  },
  {
    title: 'Preisabfrage',
    route: 'TA-PriceQuery',
    icon: 'DollarSignIcon',
    resource: 'TAR0',
    action: 'read',
  },
]